import { createApi } from "@reduxjs/toolkit/query/react";
import { createServiceBaseQuery } from "../../../../../store/client/serviceBaseQuery";

export interface Dashboard {
  id: string;
  recipeData: {
    title: string;
  };
}

export const dashboardService = createApi({
  reducerPath: "dashboardService",
  baseQuery: createServiceBaseQuery("zeusUri"),
  endpoints: (builder) => ({
    getDashboard: builder.query<Dashboard, string>({
      query: (dashboardId) => `/api/dashboards/${dashboardId}`,
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardService;
